import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@maui/elements'

export const DrawerActions = React.forwardRef((props, ref) => {
  const { children, ...restProps } = props

  return (
    <Box
      display='flex'
      alignItems='center'
      padding='spacePaddingSmall'
      borderBottomWidth='3px'
      borderBottomStyle='solid'
      borderBottomColor='colorBorderMain'
      backgroundColor='colorFillDeemphasis'
      ref={ref}
      {...restProps}
    >
      {children}
    </Box>
  )
})

DrawerActions.displayName = 'DrawerSlotTop'

DrawerActions.propTypes = {
  children: PropTypes.node,
}
